import { T, useTranslate } from '@tolgee/react';
import { useContext, useMemo, useRef, useState } from 'react';
import styled, { css } from 'styled-components';

import theme from '../../../../assets/theme';
import { useDynamicLessonStateContext } from '../../../../hooks/useCreateLessonState';
import { useMetrics } from '../../../../hooks/useMetrics';
import useRouterMatch from '../../../../hooks/useRouterMatch';
import { SocketContext } from '../../../../providers/SocketProvider/SocketProvider';
import { themeSlides } from '../../../../utils/slideThemingUtils';
import { ColorPalette } from '../../../_organisms/DesignerTabPane/AgentTab/AgentHooks';
import { Slide } from '../../../SlideComponents/slide.types';
import { CSSSlideWrapperViewer } from '../../../SlideComponents/SlideWrapperViewer';
import { GenerateLessonButton } from './ObjectiveRefinement';

const createSlideTemplate = ({
  subtitle,
  title,
}: {
  title: string;
  subtitle: string;
}): Slide => {
  return {
    id: '1',
    type: 'slide',
    width: 1920,
    height: 1080,
    version: 1,
    elements: [
      {
        x: -14.812479066574937,
        y: 760.2757671336682,
        id: '1262618418378',
        type: 'shape',
        angle: 0,
        width: 2181,
        colors: ['#FFBE89'],
        height: 260,
        opacity: 1,
        version: 1,
        borderRadius: 0,
        shapeClipPath:
          'polygon(100% 100%, 0% 100% , 0.00% 43.44%, 1.33% 45.30%, 2.67% 46.82%, 4.00% 47.96%, 5.33% 48.69%, 6.67% 48.99%, 8.00% 48.86%, 9.33% 48.31%, 10.67% 47.34%, 12.00% 45.98%, 13.33% 44.25%, 14.67% 42.20%, 16.00% 39.88%, 17.33% 37.33%, 18.67% 34.61%, 20.00% 31.79%, 21.33% 28.93%, 22.67% 26.09%, 24.00% 23.34%, 25.33% 20.74%, 26.67% 18.35%, 28.00% 16.23%, 29.33% 14.42%, 30.67% 12.96%, 32.00% 11.89%, 33.33% 11.23%, 34.67% 11.00%, 36.00% 11.20%, 37.33% 11.82%, 38.67% 12.86%, 40.00% 14.29%, 41.33% 16.07%, 42.67% 18.17%, 44.00% 20.53%, 45.33% 23.12%, 46.67% 25.86%, 48.00% 28.69%, 49.33% 31.55%, 50.67% 34.38%, 52.00% 37.11%, 53.33% 39.67%, 54.67% 42.02%, 56.00% 44.09%, 57.33% 45.85%, 58.67% 47.24%, 60.00% 48.25%, 61.33% 48.83%, 62.67% 49.00%, 64.00% 48.73%, 65.33% 48.03%, 66.67% 46.93%, 68.00% 45.44%, 69.33% 43.60%, 70.67% 41.46%, 72.00% 39.05%, 73.33% 36.44%, 74.67% 33.68%, 76.00% 30.84%, 77.33% 27.97%, 78.67% 25.16%, 80.00% 22.45%, 81.33% 19.92%, 82.67% 17.62%, 84.00% 15.59%, 85.33% 13.89%, 86.67% 12.56%, 88.00% 11.63%, 89.33% 11.11%, 90.67% 11.02%, 92.00% 11.36%, 93.33% 12.12%, 94.67% 13.29%, 96.00% 14.84%, 97.33% 16.73%, 98.67% 18.93%, 100.00% 21.37%);',
        lockedPosition: true,
        lockedFromDeletion: false,
      },
      {
        x: -11.35483576657493,
        y: 870.2258631336682,
        id: '430986043544',
        type: 'shape',
        angle: 0,
        width: 2207,
        colors: ['#F99746'],
        height: 260,
        opacity: 1,
        version: 1,
        borderRadius: 0,
        shapeClipPath:
          'polygon(100% 100%, 0% 100% , 0.00% 43.44%, 1.33% 45.30%, 2.67% 46.82%, 4.00% 47.96%, 5.33% 48.69%, 6.67% 48.99%, 8.00% 48.86%, 9.33% 48.31%, 10.67% 47.34%, 12.00% 45.98%, 13.33% 44.25%, 14.67% 42.20%, 16.00% 39.88%, 17.33% 37.33%, 18.67% 34.61%, 20.00% 31.79%, 21.33% 28.93%, 22.67% 26.09%, 24.00% 23.34%, 25.33% 20.74%, 26.67% 18.35%, 28.00% 16.23%, 29.33% 14.42%, 30.67% 12.96%, 32.00% 11.89%, 33.33% 11.23%, 34.67% 11.00%, 36.00% 11.20%, 37.33% 11.82%, 38.67% 12.86%, 40.00% 14.29%, 41.33% 16.07%, 42.67% 18.17%, 44.00% 20.53%, 45.33% 23.12%, 46.67% 25.86%, 48.00% 28.69%, 49.33% 31.55%, 50.67% 34.38%, 52.00% 37.11%, 53.33% 39.67%, 54.67% 42.02%, 56.00% 44.09%, 57.33% 45.85%, 58.67% 47.24%, 60.00% 48.25%, 61.33% 48.83%, 62.67% 49.00%, 64.00% 48.73%, 65.33% 48.03%, 66.67% 46.93%, 68.00% 45.44%, 69.33% 43.60%, 70.67% 41.46%, 72.00% 39.05%, 73.33% 36.44%, 74.67% 33.68%, 76.00% 30.84%, 77.33% 27.97%, 78.67% 25.16%, 80.00% 22.45%, 81.33% 19.92%, 82.67% 17.62%, 84.00% 15.59%, 85.33% 13.89%, 86.67% 12.56%, 88.00% 11.63%, 89.33% 11.11%, 90.67% 11.02%, 92.00% 11.36%, 93.33% 12.12%, 94.67% 13.29%, 96.00% 14.84%, 97.33% 16.73%, 98.67% 18.93%, 100.00% 21.37%);',
        lockedPosition: true,
        lockedFromDeletion: false,
      },
      {
        x: 180,
        y: 180,
        id: '53583619541',
        type: 'text',
        angle: 0,
        scale: 1,
        width: 1728,
        height: 227.859375,
        opacity: 1,
        version: 1,
        textValue: JSON.stringify([
          {
            align: 'left',
            type: 'paragraph',
            size: 145,
            children: [{ text: `${title}`, bold: true, color: '#282F33' }],
          },
        ]),
        borderRadius: 0,
        lockedPosition: false,
        lockedFromDeletion: false,
      },
      {
        x: 90.9174983,
        y: 373.4856136000001,
        id: '1420470339941',
        type: 'text',
        angle: 0,
        scale: 1,
        width: 1189,
        height: 180.71875,
        opacity: 1,
        version: 1,
        textValue: JSON.stringify([
          {
            align: 'left',
            color: '#282F33',
            type: 'paragraph',
            size: 115,
            children: [{ text: subtitle, color: '#282F33' }],
          },
        ]),
        borderRadius: 0,
        lockedPosition: false,
        lockedFromDeletion: false,
      },
    ],
    backgroundMedia: {
      fileId: '#FFF8F0',
      brightness: 0.5,
      fileMimeType: 'image/color',
    },
    contextElements: [],
    durationSeconds: null,
    dataReferenceSlideId: null,
  };
};

const COLOR_PALETTES = {
  // Default color palette (from the default theme)
  DEFAULT: {
    dark: '#F99746',
    base: '#FFBE89',
    light: '#FFEBCC',
    veryLight: '#FFF8F0',
    fontColor: '#282F33',
    backgroundColor: '#FFF8F0',
  },

  // ELA color palettes
  ELA_READING: {
    dark: '#D84C42',
    base: '#EC7070',
    light: '#F8C9C9',
    veryLight: '#FBE9E9',
    fontColor: '#282F33',
    backgroundColor: '#FBE9E9',
  },

  ELA_WRITING: {
    dark: '#2598DA',
    base: '#69B9E6',
    light: '#B3DAF5',
    veryLight: '#D6EBFA',
    fontColor: '#282F33',
    backgroundColor: '#D6EBFA',
  },

  // Math color palette
  MATH: {
    dark: '#2598DA',
    base: '#69B9E6',
    light: '#B3DAF5',
    veryLight: '#D6EBFA',
    fontColor: '#282F33',
    backgroundColor: '#D6EBFA',
  },

  // Science color palette
  SCIENCE: {
    dark: '#61B195',
    base: '#93C8B6',
    light: '#DAECE6',
    veryLight: '#EEF7F3',
    fontColor: '#282F33',
    backgroundColor: '#EEF7F3',
  },

  // Social Studies color palette
  SOCIAL_STUDIES: {
    dark: '#A575FF',
    base: '#D0B7FF',
    light: '#E8DBFF',
    veryLight: '#F1EBFF',
    fontColor: '#282F33',
    backgroundColor: '#F1EBFF',
  },
  HALLOWEEN: {
    dark: '#632400', // Deep blood red / near-black
    base: '#cd4902', // Dark brownish red (aged wood, haunted house)
    light: '#cd4902', // Pumpkin orange glow
    veryLight: '#FFF3E0', // Warm candlelight ivory
    fontColor: '#F5E6D3', // Pale bone white for text
    backgroundColor: '#0A0908', // Almost-black — night sky / shadow
  },
  SIMPLE: {
    dark: '#ffffff', // Deep golden yellow — accent / buttons
    base: '#ffffff', // Primary bright yellow
    light: '#ffffff', // Soft pastel yellow for highlights
    veryLight: '#ffffff', // Background wash, gentle and warm
    fontColor: '#282F33', // Dark gray for strong contrast
    backgroundColor: '#ffffff', // Matches veryLight for harmony
  },

  DARK_PURPLE: {
    dark: '#6C4BB3', // Deep purple-black — main background / navbar
    base: '#7e5acb', // Charcoal with a hint of violet
    light: '#9476d4', // Medium purple accent (buttons, highlights)
    veryLight: '#E5D9FF', // Soft lavender for light backgrounds or hover
    fontColor: '#F2F0FF', // Nearly white with a lilac tint
    backgroundColor: '#0B0911', // Almost black — overall background
  },

  // Other subjects color palette
  OTHER: {
    dark: '#F99746',
    base: '#FFBE89',
    light: '#FFEBCC',
    veryLight: '#FFF8F0',
    fontColor: '#282F33',
    backgroundColor: '#FFF8F0',
  },
};

export function ChooseTheme() {
  const presentationId = useDynamicLessonStateContext(
    context => context.dynamicLessonState.presentationId,
  );
  const metrics = useMetrics();
  const { t } = useTranslate();

  const themedSlides: { slide: Slide; colorPalette: ColorPalette }[] = useMemo(
    () => [
      {
        slide: themeSlides({
          slides: [
            createSlideTemplate({
              title: t('Classic Curipod', 'Classic Curipod'),
              subtitle: '',
            }),
          ],
          fromColorPalette: COLOR_PALETTES.DEFAULT,
          toColorPalette: COLOR_PALETTES.DEFAULT,
        })[0],
        colorPalette: COLOR_PALETTES.DEFAULT,
      },
      {
        slide: themeSlides({
          slides: [
            createSlideTemplate({
              title: t('Bold & Bright', 'Bold & Bright'),
              subtitle: '',
            }),
          ],
          fromColorPalette: COLOR_PALETTES.DEFAULT,
          toColorPalette: COLOR_PALETTES.SOCIAL_STUDIES,
        })[0],
        colorPalette: COLOR_PALETTES.SOCIAL_STUDIES,
      },
      {
        slide: themeSlides({
          slides: [
            createSlideTemplate({
              title: t('Cool & Calm', 'Cool & Calm'),
              subtitle: '',
            }),
          ],
          fromColorPalette: COLOR_PALETTES.DEFAULT,
          toColorPalette: COLOR_PALETTES.MATH,
        })[0],
        colorPalette: COLOR_PALETTES.MATH,
      },
      {
        slide: themeSlides({
          slides: [
            createSlideTemplate({
              title: t('Fresh & Friendly', 'Fresh & Friendly'),
              subtitle: '',
            }),
          ],
          fromColorPalette: COLOR_PALETTES.DEFAULT,
          toColorPalette: COLOR_PALETTES.SCIENCE,
        })[0],
        colorPalette: COLOR_PALETTES.SCIENCE,
      },
      {
        slide: themeSlides({
          slides: [
            createSlideTemplate({
              title: t('Big Energy', 'Big Energy'),
              subtitle: '',
            }),
          ],
          fromColorPalette: COLOR_PALETTES.DEFAULT,
          toColorPalette: COLOR_PALETTES.ELA_READING,
        })[0],
        colorPalette: COLOR_PALETTES.ELA_READING,
      },
      {
        slide: themeSlides({
          slides: [
            createSlideTemplate({
              title: t('Simple', 'Simple'),
              subtitle: '',
            }),
          ],
          fromColorPalette: COLOR_PALETTES.DEFAULT,
          toColorPalette: COLOR_PALETTES.SIMPLE,
        })[0],
        colorPalette: COLOR_PALETTES.SIMPLE,
      },
      {
        slide: themeSlides({
          slides: [
            createSlideTemplate({
              title: t('Chalkboard', 'Chalkboard'),
              subtitle: '',
            }),
          ],
          fromColorPalette: COLOR_PALETTES.DEFAULT,
          toColorPalette: COLOR_PALETTES.DARK_PURPLE,
        })[0],
        colorPalette: COLOR_PALETTES.DARK_PURPLE,
      },
      {
        slide: themeSlides({
          slides: [
            createSlideTemplate({
              title: t('Spooky Look', 'Spooky Look'),
              subtitle: '',
            }),
          ],
          fromColorPalette: COLOR_PALETTES.DEFAULT,
          toColorPalette: COLOR_PALETTES.HALLOWEEN,
        })[0],
        colorPalette: COLOR_PALETTES.HALLOWEEN,
      },
    ],
    [t],
  );

  const [isHovering, setIsHovering] = useState<ColorPalette | null>(null);
  const slideGridRef = useRef<HTMLDivElement>(null);

  const { tenantId, router } = useRouterMatch();
  const { gameAPI } = useContext(SocketContext);

  const [selectedTheme, setSelectedTheme] = useState<ColorPalette>(
    COLOR_PALETTES.DEFAULT,
  );

  const handleSelectTheme = (theme: ColorPalette) => {
    setSelectedTheme(theme);
  };

  const handleNext = () => {
    if (presentationId && gameAPI && selectedTheme) {
      metrics.logEvent('PickTheme', {
        theme: selectedTheme,
      });
      // Lesson generation has already started.
      // This step updates the color palette.
      // Then we redirect to the designer and listen to the generation
      gameAPI.getSocket().emit(
        'build:lesson:color-palette-changed',
        {
          presentationId,
          colorPalette: selectedTheme,
        },
        (_: {
          status: number;
          data: { colorPalette: ColorPalette };
          error?: { status: number; message: string };
        }) => {
          // Wait until the server acks before we redirect so that
          // disconnects are avoided
          router.replace(
            `/${tenantId}/lessons/${presentationId}/edit?buildInitialLesson=true`,
          );
        },
      );
    }
  };

  return (
    <PickThemeContainer>
      <Title $hasHistory={false} style={{ textAlign: 'center' }}>
        <T
          key="Final step: Select a Theme for Your Lesson"
          keyName="Final step: Select a Theme for Your Lesson"
          defaultValue="Final step: Select a Theme for Your Lesson"
        />
      </Title>
      <SlideGrid ref={slideGridRef}>
        {themedSlides.map((themedSlide, index) => (
          <SlideGridItem
            key={index}
            $isSelected={selectedTheme === themedSlide.colorPalette}
            $isHovering={isHovering === themedSlide.colorPalette}
            onMouseEnter={() => setIsHovering(themedSlide.colorPalette)}
            onMouseLeave={() => setIsHovering(null)}
            onClick={() => handleSelectTheme(themedSlide.colorPalette)}
          >
            <CSSSlideWrapperViewer
              aspect={{ height: 1080, width: 1920 }}
              hideLogo={true}
              slide={themedSlide.slide}
              backgroundMedia={themedSlide.slide?.backgroundMedia}
              resultView={false}
              showStaticPoll={false}
              isDiscoverTemplate={false}
              isOwner={true}
              lessonAttachments={[]}
            />
          </SlideGridItem>
        ))}
      </SlideGrid>
      <div style={{ display: 'grid', justifyContent: 'center' }}>
        <GenerateLessonButton
          onClick={handleNext}
          disabled={!selectedTheme}
          loading={false}
          styles={{
            width: '200px',
            height: '50px',
            borderRadius: '25px',
          }}
        >
          <T key="Continue" keyName="Continue" defaultValue="Continue" />
        </GenerateLessonButton>
      </div>
    </PickThemeContainer>
  );
}

const PickThemeContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 10%;
  margin: 0 auto;
  position: relative;
`;

const SlideGridItem = styled.div<{ $isSelected: boolean; $isHovering: boolean }>`
  aspect-ratio: 1920/1080;
  width: 100%;
  background-color: ${theme.colors.creatorBackgroundBeige};
  border-radius: 5px;
  overflow: hidden;
  cursor: pointer;
  outline-style: solid;
  outline-width: 4px;
  outline-color: transparent;
  transition: all 0.2s ease;
  box-shadow: ${theme.effects.floatingCreatorElementShadow};

  ${({ $isSelected }) => {
    if ($isSelected) {
      return css`
        outline: 4px solid ${theme.colors.blue};
        scale: 1.01;
      `;
    }
  }}
  ${({ $isHovering }) => {
    if ($isHovering) {
      return css`
        outline: 4px solid ${theme.colors.blue};
        scale: 1.01;
      `;
    }
  }}
`;

const SlideGrid = styled.div`
  position: relative;
  display: grid;
  width: 100%;
  grid-template-columns: repeat(4, 1fr);

  max-width: 1000px;

  @media (max-width: 800px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 550px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 350px) {
    grid-template-columns: repeat(1, 1fr);
    max-height: 520px;
    overflow-y: auto;
    box-shadow: ${theme.effects.defaultShadow} inset;
    padding: 10px;
    border-radius: 10px;
  }

  margin-bottom: 30px;
  justify-content: center;
  gap: 10px;
`;

const Title = styled.h1<{ $hasHistory: boolean }>`
  font-size: 48px;
  font-weight: 600;
  color: ${theme.colors.black};
  margin-bottom: 8px;
  opacity: ${({ $hasHistory }) => ($hasHistory ? '0' : '1')};
  margin-top: ${({ $hasHistory }) => ($hasHistory ? '-100px' : '0px')};
  transition: all 0.8s ease-in-out;

  @media (max-width: 768px) {
    font-size: 32px;
    margin-bottom: 5px;
    padding: 0 20px;
    text-align: center;
  }

  @media (max-width: 480px) {
    font-size: 28px;
    margin-bottom: 5px;
  }
`;
